"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ADOPTION_FIELDS = void 0;
var entities_1 = require("@common/entities");
var constants_1 = require("../../constants");
exports.ADOPTION_FIELDS = [
    {
        label: 'Adoption',
        type: entities_1.FieldType.YesNo,
        sequence: 1,
        name: 'anticipated_addition_adoption',
        customType: entities_1.FieldType.YesNo,
        required: true,
        enabled: true,
        options: constants_1.YES_NO_OPTIONS,
    },
    {
        label: '',
        type: entities_1.FieldType.Number,
        sequence: 2,
        name: 'anticipated_addition_adoption_val',
        customType: entities_1.FieldType.Number,
        required: true,
        enabled: true,
        isDependent: true,
    },
];
